import React from 'react';
import { Page } from '../Page';
export function PageDoseManagement() {
  return <Page pageNumber={5} variant="light" data-id="element-901">
      <div className="flex flex-col h-full" data-id="element-902">
        <div className="mb-8" data-id="element-903">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-904">
            Understanding Your Medication
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-905">
            Managing Your <span className="text-tealslate" data-id="element-906">Dose</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-907" />
        </div>

        <div className="grid grid-cols-2 gap-10 flex-1" data-id="element-908">
          {/* Left Column */}
          <div className="space-y-4" data-id="element-909">
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-910">
              As you move through this process, a question that often arises is
              how your dose should change over time.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-911">
              And the answer isn't the same for everyone.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-912">
              Some people feel a clear shift at the lowest dose. Hunger drops,
              food noise quiets down, and they're able to stay consistent
              without needing to go higher. Others don't feel much at first.
              Hunger is still there, food noise is still present, and it takes a
              higher dose before things start to click.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8] font-medium italic" data-id="element-913">
              That's normal. Not everyone responds the same way to the same
              dose.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-914">
              So instead of focusing on what dose you "should" be on, focus on
              what your body is actually telling you. You're looking for a point
              where hunger feels manageable, food noise is reduced, and you're
              able to eat in a way that supports your body while still making
              progress. That's when the medication is doing its job.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-915">
              Another piece to understand is how long the medication stays
              active in your system. Most GLP-1 medications used for weight loss
              are designed to last about a week, which is why they're taken once
              every 7 days. That doesn't mean the effect is perfectly even from
              day one to day seven. After each dose, levels rise, then gradually
              taper down as your body clears the medication.
            </p>
          </div>

          {/* Right Column */}
          <div className="space-y-4" data-id="element-916">
            <img src="https://cdn.magicpatterns.com/uploads/vYGzC2Hwa1X2o91ztrwHJU/wegovy_transparent.png" alt="Dose Progression (Wegovy) - 0.25mg to 2.4mg" className="w-full h-auto object-contain" data-id="element-917" />
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-918">
              If your dose is working well, things tend to feel consistent
              throughout the week. Hunger stays manageable, food noise stays
              low, and you're able to eat in a way that supports your goals
              without big swings.
            </p>
            <p className="text-sm text-[#3B3B3B] leading-[1.8]" data-id="element-919">
              If your dose is too low, you might notice a different pattern. The
              first few days feel solid, but toward the end of the week, hunger
              starts to come back. Food noise picks up, portions get harder to
              control, and it can feel like the medication is wearing off.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}